import {FilterItem} from "../../types/PrescriptionFilter";
import {Dayjs} from "dayjs";

export interface FilterType {
    productData: FilterItem[];
    placeData: FilterItem[];
    userData: FilterItem[];
    statuses: FilterItem[];
}

export type SelectedFiltersType = {
    productId: number[],
    placeId: number[],
    userId: number[],
    statusId: number[],
    cDtFrom: Dayjs | null,
    cDtTo: Dayjs | null,
    uDtFrom: Dayjs | null,
    uDtTo: Dayjs | null,
    page: number | null,
    pageSize: number | null
    sortBy: string | undefined
    sortDir: string | undefined
    phoneNumber: string,
    mFirstName: string,
    mLastName: string,
    flagged: boolean
}

export const selectedFiltersInitialState = {
    productId: [],
    placeId: [],
    userId: [],
    statusId: [],
    cDtFrom: null,
    cDtTo: null,
    uDtFrom: null,
    uDtTo: null,
    page: null,
    pageSize: 50,
    sortBy: "created_at",
    sortDir: "DESC",
    phoneNumber: "",
    mFirstName: "",
    mLastName: "",
    flagged: false
}

export type ProductChangeFromOtherFilterType = {
    productChanger: ''
    initialProducts: FilterItem[]
    users: FilterItem[]
    places: FilterItem[]
}

export type ProductChangeToOtherFilterType = {
    otherProductIds: FilterItem[]
    users: FilterItem[]
    places: FilterItem[]
}

export type ProductChangeFromOtherSelectedFiltersType = {
    productChanger: string,
    initialProductIds: number[],
    placeIds: number[],
    prescriptionUserIds: number[],
    cDtFrom: Dayjs | null,
    cDtTo: Dayjs | null,
    page: number,
    pageSize: number,
    sortBy: string,
    sortDir: string
}

export type ProductChangeFromOtherSelectedParamsType = {
    productChanger: string,
    initialProductIds: number[],
    placeIds: number[],
    prescriptionUserIds: number[],
    cDtFrom: string,
    cDtTo: string,
    page: number,
    pageSize: number,
    sortBy: string,
    sortDir: string
}

export type ProductChangeToOtherSelectedFiltersType = {
    otherProductIds: number[],
    placeIds: number[],
    prescriptionUserIds: number[],
    productChanger: string,
    cDtFrom: Dayjs | null,
    cDtTo: Dayjs | null,
    page: number,
    pageSize: number,
    sortBy: string,
    sortDir: string
}

export type ProductChangeToOtherSelectedParamsType = {
    otherProductIds: number[],
    placeIds: number[],
    prescriptionUserIds: number[],
    productChanger: string,
    cDtFrom: string,
    cDtTo: string,
    page: number,
    pageSize: number,
    sortBy: string,
    sortDir: string
}

export const productChangeFromOtherSelectedFiltersInitialState = {
    productChanger: '',
    initialProductIds: [],
    placeIds: [],
    prescriptionUserIds: [],
    cDtFrom: null,
    cDtTo: null,
    page: 1,
    pageSize: 10,
    sortBy: "createdAt",
    sortDir: "DESC",
}

export const productChangeToOtherSelectedFiltersInitialState = {
    otherProductIds: [],
    placeIds: [],
    prescriptionUserIds: [],
    productChanger: '',
    cDtFrom: null,
    cDtTo: null,
    page: 1,
    pageSize: 10,
    sortBy: "createdAt",
    sortDir: "DESC",
}